// src/App.tsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import LoginSuperAdmin from "./pages/LoginSuperAdmin";
import LoginUser from "./pages/LoginUser";
import DashboardSuperAdmin from "./pages/DashboardSuperAdmin";
import DashboardUser from "./pages/DashboardUser";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Page d’accueil avec choix du rôle */}
        <Route path="/" element={<Home />} />

        {/* Page de login SuperAdmin */}
        <Route path="/login-superadmin" element={<LoginSuperAdmin />} />

        {/* Page de login Utilisateur simple */}
        <Route path="/login-user" element={<LoginUser />} />

        {/* Page d'accueil du SuperAdmin */}
        <Route path="/dashboard-superadmin" element={<DashboardSuperAdmin />} />

        {/* Page d'accueil de l'Utilisateur simple */}
        <Route path="/dashboard-user" element={<DashboardUser />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
